import BACK_API from "../api/simulateAPI";


const getDepartments = async () => {
  try {
    const result = await BACK_API().get("simulation/departamentos");

    return result.data.sort((a, b) => {
      if (!a.name) return -1;
      if (!b.name) return 1;
      return a.name.localeCompare(b.name, "es", { sensitivity: "base" });
    });
  } catch (error) {
    console.log(error)
    throw error   
  }
};

export default getDepartments;
